import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLazyGetProvidersQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";

const useGetProvidersApi = (type) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);

  const [providersApi] = useLazyGetProvidersQuery();
  const get = (type) => {
    dispatch(setLoader(true));

    providersApi()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        if (type === "select") {
          let formatToSelect = res?.map((item) => ({
            value: item?.id,
            label: item?.name,
            ...item,
          }));
          setData(formatToSelect);
          return;
        }
        setData(res);
      })
      .catch((err) => {
        dispatch(setLoader(false));
      });
  };

  useEffect(() => {
    get(type);
  }, []);
  return {
    data,
  };
};

export default useGetProvidersApi;
